<template>
  <div>
    <Progress progress="76"></Progress>
      <div class="contain">
        <div class="question-box">
          <div class="question-title">
            {{ $t("customerState.statement_list[0].title") }}
          </div>
          <van-radio-group v-model="result[0].value" direction="horizontal" class="radio-box">
            <van-radio :name="1" icon-size="14" label-position="right" class="radio-left">
              <template #icon="props">
                <img class="img-icon" :src="props.checked ? RadioCheck : RadioNone" />
              </template>
              {{$t("customerState.yes") }}
            </van-radio>
            <van-radio :name="0" icon-size="14" label-position="right" class="radio-right">
              <template #icon="props">
                <img class="img-icon" :src="props.checked ? RadioCheck : RadioNone" />
              </template>
              {{
                $t("customerState.no")
              }}
            </van-radio>
          </van-radio-group>
          <div class="bottom-box" v-show="result[0].value == 0">
            {{ $t("customerState.statement_list[0].tip") }}
          </div>
        </div>

        <div class="question-box">
          <div class="question-title">
            {{ $t("customerState.statement_list[1].title") }}
          </div>
          <van-radio-group v-model="result[1].value" direction="horizontal" class="radio-box">
            <van-radio :name="1" icon-size="14" label-position="right" class="radio-left">
              <template #icon="props">
                <img class="img-icon" :src="props.checked ? RadioCheck : RadioNone" />
              </template>
              {{$t("customerState.yes") }}
            </van-radio>
            <van-radio :name="0" icon-size="14" label-position="right" class="radio-right">
              <template #icon="props">
                <img class="img-icon" :src="props.checked ? RadioCheck : RadioNone" />
              </template>
              {{
                $t("customerState.no")
              }}
            </van-radio>
          </van-radio-group>
          <div class="bottom-box1" v-show="result[1].value == 1">
            <div class="ipt-box" :class="{'focus':inputFocusId == 1}">
              <div class="ipt-main">
                <div class="val-box">
                  <span class="label" v-if="result[1].input_value || inputFocusId == 1">{{ $t('customerState.statement_list[1].input_label_1') }}</span>
                  <van-field
                    class="val"
                    v-model="result[1].input_value"
                    :placeholder="inputFocusId == 1 ? '' : $t('customerState.statement_list[1].input_label_1')"
                    @focus="inputFocus(1)"
                    @blur="blurEvent"
                  ></van-field>
                </div>
              </div>
            </div>
            <div class="ipt-box" :class="{'focus':inputFocusId == 2}">
              <div class="ipt-main">
                <div class="val-box">
                  <span class="label" v-if="result[1].input_value_2 || inputFocusId == 2">{{ $t('customerState.statement_list[1].input_label_2') }}</span>
                  <van-field
                    class="val"
                    v-model="result[1].input_value_2"
                    :placeholder="inputFocusId == 2 ? '' : $t('customerState.statement_list[1].input_label_2')"
                    @focus="inputFocus(2)"
                    @blur="blurEvent"
                  ></van-field>
                </div>
              </div>
            </div>
            <div class="upload-box">
              <UploadImg
                :img="result[1].input_value_img_url"
                @afterRead="afterRead"
                @del="delImg"
                :quality="0.5"
                :text="$t('openAccount.t000179')"
              />
            </div>
          </div>
        </div>

        <div class="question-box">
          <div class="question-title">
            {{ $t("customerState.statement_list[2].title") }}
          </div>
          <van-radio-group v-model="result[2].value" direction="horizontal" class="radio-box">
            <van-radio :name="1" icon-size="14" label-position="right" class="radio-left">
              <template #icon="props">
                <img class="img-icon" :src="props.checked ? RadioCheck : RadioNone" />
              </template>
              {{$t("customerState.yes") }}
            </van-radio>
            <van-radio :name="0" icon-size="14" label-position="right" class="radio-right">
              <template #icon="props">
                <img class="img-icon" :src="props.checked ? RadioCheck : RadioNone" />
              </template>
              {{
                $t("customerState.no")
              }}
            </van-radio>
          </van-radio-group>
          <div class="bottom-box2" v-show="result[2].value == 1">
            <div class="ipt-box" :class="{'focus':inputFocusId == 3}">
              <div class="ipt-main">
                <div class="val-box">
                  <span class="label" v-if="result[2].input_value || inputFocusId == 3">{{ $t('customerState.statement_list[2].input_label_1') }}</span>
                  <van-field
                    class="val"
                    v-model="result[2].input_value"
                    :placeholder="inputFocusId == 3 ? '' : $t('customerState.statement_list[2].input_label_1')"
                    @focus="inputFocus(3)"
                    @blur="blurEvent"
                  ></van-field>
                </div>
              </div>
            </div>
            <div class="ipt-box" :class="{'focus':inputFocusId == 4}">
              <div class="ipt-main">
                <div class="val-box">
                  <span class="label" v-if="result[2].input_value_2 || inputFocusId == 4">{{ $t('customerState.statement_list[2].input_label_2') }}</span>
                  <van-field
                    class="val"
                    v-model="result[2].input_value_2"
                    :placeholder="inputFocusId == 4 ? '' : $t('customerState.statement_list[2].input_label_2')"
                    @focus="inputFocus(4)"
                    @blur="blurEvent"
                  ></van-field>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="question-box">
          <div class="question-title">
            {{ $t("customerState.statement_list[3].title") }}
          </div>
          <van-radio-group v-model="result[3].value" direction="horizontal" class="radio-box">
            <van-radio :name="1" icon-size="14" label-position="right" class="radio-left">
              <template #icon="props">
                <img class="img-icon" :src="props.checked ? RadioCheck : RadioNone" />
              </template>
              {{$t("customerState.yes") }}
            </van-radio>
            <van-radio :name="0" icon-size="14" label-position="right" class="radio-right">
              <template #icon="props">
                <img class="img-icon" :src="props.checked ? RadioCheck : RadioNone" />
              </template>
              {{
                $t("customerState.no")
              }}
            </van-radio>
          </van-radio-group>
          <div class="bottom-box" v-show="result[3].value == 1">
            {{ $t("customerState.statement_list[3].tip") }}
          </div>
        </div>

        <div class="question-box last-box">
          <div class="question-title">
            {{ $t("customerState.statement_list[4].title") }}
          </div>
          <van-radio-group v-model="result[4].value" direction="horizontal" class="radio-box">
            <van-radio :name="1" icon-size="14" label-position="right" class="radio-left">
              <template #icon="props">
                <img class="img-icon" :src="props.checked ? RadioCheck : RadioNone" />
              </template>
              {{$t("customerState.yes") }}
            </van-radio>
            <van-radio :name="0" icon-size="14" label-position="right" class="radio-right">
              <template #icon="props">
                <img class="img-icon" :src="props.checked ? RadioCheck : RadioNone" />
              </template>
              {{
                $t("customerState.no")
              }}
            </van-radio>
          </van-radio-group>
          <div class="bottom-box2" v-show="result[4].value == 1">
            <div class="ipt-box" :class="{'focus':inputFocusId == 5}">
              <div class="ipt-main">
                <div class="val-box">
                  <span class="label" v-if="result[4].input_value || inputFocusId == 5">{{ $t('customerState.statement_list[4].input_label_1') }}</span>
                  <van-field
                    class="val"
                    v-model="result[4].input_value"
                    :placeholder="inputFocusId == 5 ? '' : $t('customerState.statement_list[4].input_label_1')"
                    @focus="inputFocus(5)"
                    @blur="blurEvent"
                  ></van-field>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 第六条暂时隐藏
        <div class="question-box last-box">
          <div class="question-title">
            {{ $t("customerState.statement_list[5].title") }}
          </div>
          <van-radio-group v-model="result[5].value" direction="horizontal" class="radio-box">
            <van-radio :name="1" icon-size="14" label-position="right" class="radio-left">
              <template #icon="props">
                <img class="img-icon" :src="props.checked ? RadioCheck : RadioNone" />
              </template>
              {{$t("customerState.yes") }}
            </van-radio>
            <van-radio :name="0" icon-size="14" label-position="right" class="radio-right">
              <template #icon="props">
                <img class="img-icon" :src="props.checked ? RadioCheck : RadioNone" />
              </template>
              {{
                $t("customerState.no")
              }}
            </van-radio>
          </van-radio-group>
          <div class="bottom-box" v-show="result[5].value == 1">
            {{ $t("customerState.statement_list[5].tip") }}
          </div>
        </div>
        -->

<!--        <div class="question-box last-box">-->
<!--          <div class="question-title">-->
<!--            {{ $t("customerState.statement_list[6].title") }}-->
<!--          </div>-->
<!--          <van-radio-group v-model="result[6].value" direction="horizontal" class="radio-box">-->
<!--            <van-radio :name="1" icon-size="14" label-position="right" class="radio-left">-->
<!--              <template #icon="props">-->
<!--                <img class="img-icon" :src="props.checked ? RadioCheck : RadioNone" />-->
<!--              </template>-->
<!--              {{$t("customerState.yes") }}-->
<!--            </van-radio>-->
<!--            <van-radio :name="0" icon-size="14" label-position="right" class="radio-right">-->
<!--              <template #icon="props">-->
<!--                <img class="img-icon" :src="props.checked ? RadioCheck : RadioNone" />-->
<!--              </template>-->
<!--              {{-->
<!--                $t("customerState.no")-->
<!--              }}-->
<!--            </van-radio>-->
<!--          </van-radio-group>-->
<!--          <div class="bottom-box2" v-show="result[6].value == 0">-->
<!--            <div class="ipt-box" :class="{'focus':inputFocusId == 6}">-->
<!--              <div class="ipt-main">-->
<!--                <div class="val-box">-->
<!--                  <span class="label" v-if="result[6].input_value || inputFocusId ==6">{{ $t('customerState.statement_list[2].input_label_1') }}</span>-->
<!--                  <van-field-->
<!--                    class="val"-->
<!--                    v-model="result[2].input_value"-->
<!--                    :placeholder="inputFocusId == 6 ? '' : $t('customerState.statement_list[6].input_label_1')"-->
<!--                    @focus="inputFocus(6)"-->
<!--                    @blur="blurEvent"-->
<!--                  ></van-field>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="ipt-box" :class="{'focus':inputFocusId == 7}">-->
<!--              <div class="ipt-main">-->
<!--                <div class="val-box">-->
<!--                  <span class="label" v-if="result[6].input_value_2 || inputFocusId == 7">{{ $t('customerState.statement_list[6].input_label_2') }}</span>-->
<!--                  <van-field-->
<!--                    class="val"-->
<!--                    v-model="result[6].input_value_2"-->
<!--                    :placeholder="inputFocusId == 7 ? '' : $t('customerState.statement_list[6].input_label_2')"-->
<!--                    @focus="inputFocus(7)"-->
<!--                    @blur="blurEvent"-->
<!--                  ></van-field>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->

        <nav-buttons
          :next-text="$route.query.change == 1 ? $t('openAccount.t000094') : $t('openAccount.t000095')"
          @on-next="handleSaveCustomerState" :disabled="getNextDisabled || detailLoading" navigationType="back"></nav-buttons>

      </div>
    </div>
</template>

<script>
import navButtons from "../components/navButtons.vue";
import Progress from "../components/Progress.vue";
import { Checkbox, CheckboxGroup, Field, Radio, RadioGroup, Toast } from "vant";
import { result } from "lodash/object";
import RadioNone from '@/assets/images/open-account/radio.png'
import RadioCheck from '@/assets/images/open-account/radio_check.png'
import UploadImg from "@/views/open-account/components/UploadImg.vue";
export default {
  components: {
    UploadImg,
    // eslint-disable-next-line vue/no-unused-components
    VanCheckbox: Checkbox,
    // eslint-disable-next-line vue/no-unused-components
    VanCheckboxGroup: CheckboxGroup,
    VanRadio: Radio,
    VanRadioGroup: RadioGroup,
    VanField: Field,
    navButtons,
    Progress
  },
  data() {
    return {
      RadioNone,
      RadioCheck,
      result: [
        {
          value: 1
        },
        {
          value: 0,
          input_value: "",
          input_value_2: "",
          input_value_img: ""
        },
        {
          value: 0,
          input_value: "",
          input_value_2: ""
        },
        {
          value: 0
        },
        {
          value: 0,
          input_value: ""
        },
        {
          value: 0
        },
        {
          value: 1,
          input_value: "",
          input_value_2: ""
        }],
      process_id:'',
      detailLoading:true,
      inputFocusId:null
    }
  },
  computed: {
    bgColor() {
      return this.$store.getters["common/bgColor"];
    },
    getNextDisabled(){
      let btnDisabled = false
      if(this.result[0].value == 0) {  // 第一题不可以选否
        btnDisabled = true
      }
      if(this.result[1].value == 1){ // 第二题如果选了是，必须填写完表单
        if(!this.result[1].input_value || !this.result[1].input_value_2  || !this.result[1].input_value_img){
          btnDisabled = true
        }
      }
      if(this.result[2].value == 1){ // 第二题如果选了是，必须填写完表单
        if(!this.result[2].input_value_2 || !this.result[2].input_value){
          btnDisabled = true
        }
      }
      if(this.result[3].value == 1){ // 第四题不可以选是
          btnDisabled = true
      }
      if(this.result[4].value == 1){ // 第五题如果选了是, 必须填写完表单
          if(!this.result[4].input_value){
            btnDisabled = true
          }
      }
      // if(this.result[5].value == 1){
      //   btnDisabled = true
      // }
      return btnDisabled
    }
  },
  created() {
    this.isChange = this.$route.query.change;
    this.handDetail()
  },
  methods: {
    afterRead(res) {
      this.result[1].input_value_img_url = res.url;
      this.result[1].input_value_img = res.content;
      this.$forceUpdate();
    },
    delImg() {
      this.result[1].input_value_img = "";
      this.result[1].input_value_img_url = "";
      // 通知服务端删除照片 不然下一次还是这个图的
      const params = {
        process_id: this.process_id,
        step_code: 11,
        step_order: "11",
        config_data: {
          customer_state: this.result
        }
      };
      this.$apis.supplementSaveApi(params);
      this.$forceUpdate();
    },
    handDetail() {
      const params = {
        step_code:'1,11'
      }
      this.$apis.accountSituationV2(params).then(res => {

        this.detailLoading = false
        this.process_id = res?.process_info["1"]?.process_id;
        const { config_data } = res?.process_info?.["11"] || {};
        
        if (config_data) {
          this.result.customer_state = JSON.parse(config_data);
          this.$forceUpdate();
        }
      });
    },
    inputFocus(id){
      this.inputFocusId = id;
    },
    blurEvent() {
      this.inputFocusId = '';
    },
    handleSaveCustomerState() {
      if(this.getNextDisabled){
        return
      }
      const toastLoading = Toast.loading({
        duration: 0,
        forbidClick: true,
        loadingType: "spinner",
        message: this.$t("common.loading_text")
      });
      const prams = JSON.parse(JSON.stringify(this.result));
      prams[1].input_value_img_url = ""
      this.$apis
        .supplementSaveApi({
          process_id: this.process_id,
          step_code: 11,
          step_order: 11,
          config_data: {
            customer_state: prams
          }
        }).then(res => {
        if(this.isChange == 1){
          this.$router.go(-1)
        }else{
          if(res){
            this.$router.push({ path: "/open-account/serverOpening" }).finally(() => {
              toastLoading.clear();
            });
          }

        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
@black: #1B1C24;
.contain{
  margin-top: 120px;
  padding-left: 32px;
  padding-right: 32px;
  .question-box{
    width: 100%;
    margin-top: 48px;
    .question-title{
      color: #17161C;
      font-size: 32px;
      font-weight: 500;
    }
    .radio-box{
      display: flex;
      margin-top: 24px;
      .radio-left{
        flex: 1;
        text-align: left;
      }
      .radio-right{
        flex: 1;
        text-align: right;
      }
    }
    .bottom-box{
      border: 2px dashed rgba(23,22,28,0.45);
      border-radius: 8px;
      line-height: 40px;
      margin-top: 12px;
      color: #F24E1E;
      font-size: 24px;
      padding-left: 24px;
      padding-top: 20px;
      padding-bottom: 20px;
    }
    .bottom-box1{
      margin-top: 12px;
      border: 2px dashed rgba(23,22,28,0.45);
      border-radius: 8px;
      padding: 20px;
      .bottom-card{
        height: 132px;
        border: 1px solid rgba(23,22,28,0.45);
        border-radius: 8px;
        margin: 24px;
        padding-bottom: 20px;
        .label{
          font-size: 24px;
          color: #747377;
          margin-left: 32px;
          margin-top: 20px;
        }
        .input{
          margin-left: 10px;
        }
      }
      .bottom-card1{
        height: 100px;
        border: 1px solid rgba(23,22,28,0.45);
        border-radius: 8px;
        margin: 24px;
        .input{
          margin-left: 10px;
          margin-top: 5px;
        }
      }

    }
    .bottom-box2{
      margin-top: 12px;
      border: 2px dashed rgba(23,22,28,0.45);
      border-radius: 8px;
      padding-top: 30px;
      padding-left: 20px;
      padding-right: 20px;
      .bottom-card1{
        height: 100px;
        border: 1px solid rgba(23,22,28,0.45);
        border-radius: 8px;
        margin: 24px;
        .input{
          margin-left: 10px;
          margin-top: 5px;
        }
      }
    }
  }
  .last-box{
    padding-bottom: 200px;
  }
}
.black-theme{
  .contain{
    .question-box{
      .question-title{
        color: #FFFFFF;
      }
    }
    /deep/ .van-radio__label{
      color: #FFFFFF;
    }
    .bottom-box{
      border: 2px dashed rgba(255,255,255,0.45);
    }
    .bottom-box1{
      border: 2px dashed rgba(255,255,255,0.45);
      .bottom-card{
        background: #14151D;
        border: 1px solid rgba(255,255,255,0.45);
        .label{
          color: #9D9D9F;
        }
      }
      .bottom-card1{
        border: 1px solid rgba(255,255,255,0.45);
      }
    }
    .bottom-box2{
      border: 2px dashed rgba(255,255,255,0.45);
      .bottom-card1{
        border: 1px solid rgba(255,255,255,0.45);
      }
    }
  }
  .ipt-box{
    &.focus{
      .ipt-main{
        &:after{
          border-color: rgba(255,255,255,1);
        }
      }
    }
    &.error{
      .ipt-main{
        &:after{
          border-color: #fd2626;
        }
      }
    }
    .ipt-main{
      &:after{
        border-color: rgba(255,255,255,0.25);
      }
      .label{
        color: #9D9D9F;
      }
      .icon-arrow{
        background: url("../../../assets/images/open-account/dark_icon.png") no-repeat;
        width: 32px;
        height: 32px;
        background-size: 100% 100%;
      }
      .val{
        color: #fff;
        ::v-deep{
          .van-cell__value input::placeholder {
            color: #9D9D9F !important;
          }
          textarea{
            color: #fff;
          }
        }
      }
    }
  }
}
// icon
.img-icon{
  width: 28px;
  height: 28px;
  padding-top: 6px;
}
.ipt-box {
  margin-bottom: 24px;
  &.focus{
    border-color: #17161C;
    .ipt-main{
      &:after{
        border-color: #17161C;
      }
      ::v-deep .van-cell{
        input {
          &::placeholder {
            font-size: 0;
          }
        }
      }
    }
  }
  &.error{
    .ipt-main {
      &:after {
        border-color: #FD2626;
      }
    }
  }
  .ipt-main {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 32px;
    min-height: 56px;
    position: relative;
    &:after{
      content: '';
      position: absolute;
      margin-top: -1px;
      top: -50%;
      left: -50%;
      width: 200%;
      height: 200%;
      border: 1px solid rgba(23, 22, 28, 0.25);
      transform: scale(0.5);
      border-radius: 20px;
    }
    .val-box {
      position: relative;
      flex: 1;
      display: flex;
      z-index: 1;
      flex-direction: column;
      line-height: 1;
      font-size: 32px;
      @keyframes labelAni{
        0%{
          font-size: 28px;
        }
        100%{
          font-size: 24px;
        }
      }
      .label {
        color: #747377;
        padding: 4px 0 20px;
        font-size: 24px;
        transform: translate3d(0,0,0);
            animation: labelAni .2s .1s linear both;
        &.placeholder {
          padding: 12px 0 6px 0;
          font-size: 28px;
          animation: none;
        }
      }
      ::v-deep .van-cell {
        min-height: 0px;
        font-size: 32px;
        line-height: 32px;
        input{
          &::placeholder {
            font-size: 28px;
            color: #747377;
            font-weight: normal;
          }
          &:focus ~ .van-field__body{
            background: red;
          }
        }
        textarea {
          font-size: 32px;
          line-height: 35px;
          min-height: 70px;
          color: #17161c;
        }
      }
      .val {
        padding: 0;
        line-height: 36px;
        color: #17161c;
        font-weight: 500;
      }
    }
    .icon-arrow {
      width: 32px;
      height: 32px;
      background: url("../../../assets/images/arrow-down.png") no-repeat;
      background-size: 100% 100%;
    }
  }
  .error {
    display: none;
    margin-top: 12px;
    color: #fd2626;
    font-size: 24px;
    &.show{
      display: block;
    }
    &.right{
      text-align: right;
    }
  }
  &.error{
    .ipt-main{
      border-color: #fd2626;
    }
    .error{
      display: block;
    }
  }
}
/deep/ .van-radio__label{
  padding-top: 14px;
}
@supports (-webkit-touch-callout: none) {
  .img-icon {
    transform: translateY(-2px);
  }
}

</style>
